<!--
    描述：登录页面
    时间：2021-03-26
    Created by 王帅
-->
<template>
    <div class="login-main">
        <!-- 头部信息 -->
        <div class="login-header">
            <div class="login-logo">
                <img class="logo-img" src="@/assets/images/login_logo_dx.png" alt="" />
            </div>
            <span class="title">审计管理系统 </span>
        </div>

        <!-- 中间banner -->
        <div class="login-banner">
            <div class="login-box">
                <el-form
                    ref="loginForm"
                    :model="loginForm"
                    :rules="loginRules"
                    class="login-form"
                    autocomplete="on"
                    label-position="left"
                    label-width="0"
                >
                    <div class="title-container">审计管理系统</div>

                    <!-- 临时加的姓名、密码 -->
                    <el-form-item prop="username">
                        <el-row>
                            <el-col :span="2" class="text-center">
                                <span class="svg-container">
                                    <svg-icon icon-class="user" />
                                </span>
                            </el-col>
                            <el-col :span="20">
                                <el-input
                                    ref="username"
                                    v-model="loginForm.username"
                                    placeholder="请输入用户名称"
                                    name="username"
                                    type="text"
                                    tabindex="1"
                                    @keyup.enter.native="handleLogin"
                                    autocomplete="on"
                                ></el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>

                    <!-- 用户密码 -->
                    <el-tooltip
                        v-model="capsTooltip"
                        content="大写已开启"
                        placement="right"
                        manual
                    >
                        <el-form-item prop="password">
                            <el-row>
                                <el-col :span="2" class="text-center">
                                    <span class="svg-container">
                                        <svg-icon icon-class="password" />
                                    </span>
                                </el-col>
                                <el-col :span="20">
                                    <el-input
                                        :key="passwordType"
                                        ref="password"
                                        v-model="loginForm.password"
                                        :type="passwordType"
                                        placeholder="请输入密码"
                                        name="password"
                                        tabindex="2"
                                        autocomplete="on"
                                        @keyup.native="checkCapslock"
                                        @blur="capsTooltip = false"
                                        @keyup.enter.native="handleLogin"
                                    />
                                </el-col>
                                <el-col :span="2">
                                    <span class="show-pwd" @click="showPwd">
                                        <svg-icon
                                            :icon-class="
                                                passwordType === 'password'
                                                    ? 'eye'
                                                    : 'eye-open'
                                            "
                                        />
                                    </span>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-tooltip>

                    <!-- 手机号码 -->
                    <!-- <el-form-item prop="phone">
                        <el-input
                            ref="phone"
                            v-model="loginForm.phone"
                            placeholder="请输入手机号码"
                            name="phone"
                            type="text"
                            clearable
                            tabindex="1"
                        ></el-input>
                    </el-form-item> -->

                    <!-- 验证码 -->
                    <!-- <el-form-item prop="verifyCode">
                        <el-row>
                            <el-col :span="13">
                                <el-input
                                    placeholder="请输入验证码"
                                    name="verifyCode"
                                    v-model="loginForm.verifyCode"
                                    tabindex="1"
                                    clearable
                                    @keyup.enter.native="handleLogin"
                                ></el-input>
                            </el-col>
                            <el-col :span="10" :offset="1">
                                <el-button
                                    class="login-btn btn-blue"
                                    :disabled="codeLoading"
                                    @click="getSmsCode"
                                    >{{ btnText }}</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form-item> -->

                    <el-button
                        :loading="btnLoading"
                        class="login-btn btn-blue"
                        @click.native.prevent="handleLogin"
                        >确认登录</el-button
                    >
                </el-form>
            </div>
        </div>

        <!-- 底部信息 -->
        <div class="login-footer">
            <p class="footer-text">技术支持：安徽本末数据科技有限公司</p>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "",
    data() {
        return {
            loginForm: {
                phone: "",
                verifyCode: "",
                username: "",
                password: "",
            },
            loginRules: {
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        message: "手机号格式不正确",
                    },
                ],
                verifyCode: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "请输入验证码",
                        // validator: validatePassword
                    },
                ],
                username: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: 'blur'
                    }
                ],
                password: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: 'blur'
                    }
                ]
            },
            btnText: "点击获取验证码",
            passwordType: "password",
            capsTooltip: false,
            codeLoading: false,
            codeNum: 60,
            codeTimer: null,
            btnLoading: false,
            redirect: undefined,
            otherQuery: {},
        };
    },
    mounted() {
        // 初始聚焦
        // if (this.loginForm.phone === "") {
        //     this.$refs.phone.focus();
        // } else if (this.loginForm.verifyCode === "") {
        //     this.$refs.verifyCode.focus();
        // }

        if (this.loginForm.username === "") {
            this.$refs.username.focus();
        } else if (this.loginForm.password === "") {
            this.$refs.password.focus();
        }
    },
    methods: {
        // 检查是否开启了大写
        checkCapslock(e) {
            const { key } = e;
            this.capsTooltip = key && key.length === 1 && key >= "A" && key <= "Z";
        },

        // 是否显示密码(改变密码框 type)
        showPwd() {
            if (this.passwordType === "password") {
                this.passwordType = "";
            } else {
                this.passwordType = "password";
            }
            this.$nextTick(() => {
                this.$refs.password.focus();
            });
        },

        ...mapActions("user", ["loginIn", "mobileLogin"]),

        // 点击获取验证码
        getSmsCode() {
            this.codeLoading = true;
            this.codeNum = 60;

            // 判断是否填了手机号
            if (this.loginForm.phone.trim() === "") {
                this.$message.info("请先填写手机号！");
                setTimeout(() => {
                    this.codeLoading = false;
                }, 1500);
                return;
            }

            // 验证手机号码格式是否正确
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (!reg.test(this.loginForm.phone.trim())) {
                this.$message.warning("请输入正确的手机号码！");
                setTimeout(() => {
                    this.codeLoading = false;
                }, 1500);
                return;
            }

            // 发送验证码
            sendToMobile({
                phone: this.loginForm.phone.trim(), // ----手机号
                type: "phone", //-----类型写死
            })
                .then((res) => {
                    // console.log(res);
                    if (res.operationCode === 1) {
                        this.$message.success("短信发送成功，请注意查看！");

                        // 等待文字
                        this.codeTimer = setInterval(() => {
                            this.btnText = `${this.codeNum}s 后再次点击`;

                            if (this.codeNum === 0) {
                                clearInterval(this.codeTimer);
                                this.btnText = "点击获取验证码";
                                this.codeLoading = false;
                            }
                            this.codeNum--;
                        }, 1000);
                    } else {
                        this.btnText = "点击获取验证码";
                        this.codeLoading = false;
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.codeTimer ? clearInterval(this.codeTimer) : "";
                    this.btnText = "点击获取验证码";
                    this.codeLoading = false;
                    return;
                });
        },

        // 登录
        handleLogin() {
            this.btnLoading = true;

            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    // 登录接口
                    this.loginIn({
                        // username: '管理员',
                        username: this.loginForm.username,
                        password: this.loginForm.password,
                    })
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.operationCode === 1) {
                                if(res.msg=='faild'){
                                    this.$message.error(res.data)
                                    return
                                }

                                this.$router.push({
                                    path: "/main",
                                });
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                        .catch(() => {
                            this.btnLoading = false;
                        });
                    return;

                    // 登录接口
                    this.mobileLogin({
                        phone: this.loginForm.phone,
                        verifyCode: this.loginForm.verifyCode,
                    })
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.operationCode === 1) {
                                this.$router.push({
                                    path: "/main",
                                });
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                        .catch(() => {
                            this.btnLoading = false;
                        });
                } else {
                    setTimeout(() => {
                        this.btnLoading = false;
                    }, 2000);
                    return false;
                }
            });
        },

        // 获取其它参数
        getOtherQuery(query) {
            return Object.keys(query).reduce((acc, cur) => {
                if (cur !== "redirect") {
                    acc[cur] = query[cur];
                }
                return acc;
            }, {});
        },
    },

    computed: {
        // 路由列表
        routerList() {
            return this.$router.options.routes;
        },
    },
};
</script>

<style scoped lang="less">
.login-main {
    height: 100%;
    background-color: #fff;

    .login-header {
        height: 10vh;
        box-shadow: 0px 0px 10px 0px rgba(57, 142, 141, 0.5);
        padding: 0 17%;
        font-size: 2.5vh;
        color: #000;
        display: flex;
        align-items: center;

        .login-logo {
            height: 50%;
            margin-right: 30px;
        }

        img {
            height: 100%;
        }
    }

    .login-banner {
        height: 44vh;
        // height: 460px;
        background: url("../../assets/images/login_banner_bg.jpg") no-repeat;
        background-size: 100% 100%;
        position: relative;

        .login-box {
            position: absolute;
            top: 10%;
            right: 19%;
            width: 22%;
            height: 80%;
            min-width: 320px;
            padding: 10px;
            background: #ffffff4d;
            box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
            border-radius: 10px;
        }

        .login-form {
            height: 100%;
            padding: 0 7.5%;
            background-color: #fff;
            font-size: 2.5vh;
            overflow: hidden;
            overflow-y: auto;
        }

        .title-container {
            height: 28%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .login-btn {
            width: 100%;
            height: 40px;
            padding: 0;
        }
    }

    .login-footer {
        font-size: 14px;
        color: #999;
        text-align: center;
        padding-top: 30px;
    }

    .login-box /deep/ .el-input__inner {
        background: transparent;
        border: 0;
        -webkit-appearance: none;
        border-radius: 0;
        // color: #fff;
        // caret-color: #fff;
    }

    .login-box /deep/ .el-form-item {
        border: 1px solid hsla(0, 0%, 100%, 0.1);
        background: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        color: #454545;
    }
}
</style>
